import React from 'react';
import PropTypes from 'prop-types';
import { resolve, select } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import Button from 'nucleus-core/buttons/Button';
import { tapOrClick } from 'nucleus-core/touchEventHandlers';
import { Speaker as SpeakerType, SpeakerDisplayOptions } from '../../interfaces/eventPropTypes';
import SpeakerProfileImage from './ProfileImage/SpeakerProfileImage';

export default class Speaker extends React.Component {
  static propTypes = {
    speaker: SpeakerType,
    viewBioButtonText: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    style: PropTypes.any.isRequired,
    classes: PropTypes.any.isRequired,
    displayOptions: SpeakerDisplayOptions,
    displayViewBioButton: PropTypes.bool.isRequired,
    showBioModal: PropTypes.func.isRequired
  };

  render() {
    const { speaker, translate, viewBioButtonText, displayOptions, displayViewBioButton, showBioModal, classes, style }
      = this.props;
    const { id, firstName, lastName, prefix, title, company } = speaker;
    return (
      <div>
        { displayOptions.profileImage &&
          <SpeakerProfileImage
            classes={classes}
            style={style}
            speaker={speaker}
          /> }
        <div {...resolve(this.props, 'speakerName')} {...resolveTestId(this.props, '-name')} >
          { displayOptions.prefix && <span>{ prefix } </span> }
          <span>{ translate(firstName) } </span>
          <span>{ translate(lastName) }</span>
        </div>
        { displayOptions.title && <div
          {...resolve(this.props, 'speakerTitle')}
          {...resolveTestId(this.props, '-title')}
        >
          <span>{ translate(title) }</span>
        </div>}
        { displayOptions.company && <div
          {...resolve(this.props, 'speakerCompany')}
          {...resolveTestId(this.props, '-company')}
        >
          <span>{ translate(company) }</span>
        </div>}
        { displayViewBioButton &&
          <div {...resolve(this.props, 'viewBioButtonContainer')} >
            <Button
              {...resolveTestId(this.props, '-viewBioButton')}
              {...select(this.props, 'viewBioButton', 'button')}
              title={translate(viewBioButtonText)}
              {...tapOrClick(() => showBioModal(id))}
            />
          </div>}
      </div>
    );
  }
}
